// extracted by mini-css-extract-plugin
export default {"boxBtn":"button-box_boxBtn__FAA4J"};